module.exports = __webpack_public_path__ + "img/rightArrow.bbcdf2f8.svg";